module.exports = __webpack_public_path__ + "static/media/protocol.29120140.svg";